goog.provide("shadow.js.shim.module$src$svg$wpp$content$cloud_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$cloud_svg");
shadow.js.shim.module$src$svg$wpp$content$cloud_svg = shadow.js.nativeProvides["src/svg/wpp/content/cloud.svg"] = shadow$bridge("src/svg/wpp/content/cloud.svg");
module$shadow_js_shim_module$src$svg$wpp$content$cloud_svg.default = shadow.js.shim.module$src$svg$wpp$content$cloud_svg;
